// @flow
import React, { Fragment, Component } from 'react';
import type { BlocContent } from 'types/NewsletterBloc';
import type { CardType, NewsNunType } from 'types/PageList';
import type { ArticleType } from 'types/Article';
import type { Status } from 'types/Status';

import Description from 'components/fragments/text/Description';
import CardThumbnail from 'components/fragments/card/CardThumbnail';
import Breadcrumb from 'components/fragments/Breadcrumb';
import FooterArticle from 'components/newsletter/FooterArticle';
import FooterNews from 'components/page/FooterNews';

type Props = {
  title: string,
  description: BlocContent[],
  label: {
    id: number,
    name: string,
    slug: string
  },
  featured_media: {
    src: string,
    legend: string
  },
  liste_enfants: CardType[],
  liste_cards: CardType[],
  articles: ArticleType[],
  news: NewsNunType[],
  status: Status,
  match: {
    params: {
      slug: string
    }
  },
  pageSlug: string
};

class PageHubSelections extends Component<Props> {

  _renderContent = () => {
    const { liste_enfants } = this.props;

    return liste_enfants.map<any>((liste, index) => {
      return(
        <Fragment key={index}>
          <h3 className={ index === 0 ? 'mb-3 ft-400 ft-white' : 'mb-3 ft-400'}>{liste.title}</h3>
          <div className='row mb-6 mb-md-7 mb-lg-8'>
            {liste.liste_enfants && this._renderPartenaireCards(liste.liste_enfants)}
          </div>
        </Fragment>
      );
    });
  }

  _renderPartenaireCards = (cards: Array<CardType>): Array<any> => {
    const { slug } = this.props.match.params;

    return cards.map((card, index) => {
      let classNameContainer = 'col col-md-6 col-lg-4 mb-2 mb-md-3 mb-lg-4';

      let url = `/${slug}/${card.object_slug}`;
      if (card.object_slug.startsWith('/')) {
        url = card.object_slug;
      }

      return (
        <div key={index} className={classNameContainer}>
          <CardThumbnail
            url={url}
            backgroundUrl={card.featured_media}
            title={card.title}
            desc={card.description}
            linkLabel={card.texte_cta}
          />
        </div>
      );
    });
  };

  _getTextByType = (type: 'title'|'description', index: number): string => {
    const { liste_enfants } = this.props;

    if (liste_enfants && liste_enfants[index] && liste_enfants[index][type]) {
      return liste_enfants[index][type];
    }

    return (typeof this.props[type] === 'string' && this.props[type]) || '';
  }

  render() {
    const {
      featured_media,
      title,
      articles,
      news,
      label,
      description
    } = this.props;

    return (
      <Fragment>
        <section className="banner banner--big">
          <div className="banner__thumbnail img-blue-dark" style={{ backgroundImage: `url(${featured_media.src})` }} />
          <div className="container">
            <Breadcrumb elements={[{ name: 'accueil', to: '/' }, title]} isDark />
            <h1 className="ft-h2">{title}</h1>
            {description && description.length > 0 &&
            <div className="banner__desc">
              <Description description={description}/>
            </div>}
          </div>
        </section>
        <div className="container">
          {this._renderContent()}
          { news.length > 0 &&
          <FooterNews news={news} slug={''} label={title} /> }
          { news.length === 0 && articles.length > 0 &&
          <FooterArticle articles={articles} slug={label.slug} label={label.name} /> }
        </div>
      </Fragment>
    );
  }
}

export default PageHubSelections;
